var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});

// src/bundles/bundleManagement.ts
import { gql } from "graphql-request";

// src/common/constants.ts
var MOVE_TYPES = {
  DRIVE: "drive",
  RIDE: "ride"
};
var VALID_MOVE_TYPES = Object.values(MOVE_TYPES);
var RIDE_TYPES = {
  AUTO: "auto",
  LYFT: "lyft",
  SHUTTLE: "shuttle",
  UBER: "uber"
};
var VALID_RIDE_TYPES = Object.values(RIDE_TYPES);
var RIDE_POSITION = {
  AFTER: "after",
  BEFORE: "before"
};
var VALID_RIDE_POSITIONS = Object.values(RIDE_POSITION);
var USE_CASES = {
  CONCIERGE_PICKUP: "concierge-pu",
  CONCIERGE_RETURN: "concierge-ret",
  CONCIERGE_HANGTAG: "concierge-hangtag",
  CONCIERGE_LOANER_PICKUP: "concierge-loaner-pu",
  CONCIERGE_LOANER_RETURN: "concierge-loaner-ret",
  CONCIERGE_LOANER_HANGTAG: "concierge-loaner-hangtag",
  ONE_WAY: "one-way",
  ONE_WAY_HANGTAG: "one-way-hangtag",
  ONE_WAY_SHUTTLE: "one-way-shuttle",
  ONE_WAY_HANGTAG_SHUTTLE: "one-way-hangtag-shuttle",
  INTERNAL: "internal",
  ROUND_TRIP: "round-trip"
};
var VALID_USE_CASES = Object.values(USE_CASES);
var SCENARIO_TYPES = {
  CONCIERGE_PICKUP: "concierge-pu",
  CONCIERGE_PICKUP_NO_RIDESHARE: "concierge-pu-no-rideshare",
  // CONCIERGE_PICKUP_RIDESHARE_AFTER: 'concierge-pu-rideshare-after',
  // CONCIERGE_PICKUP_RIDESHARE_BEFORE: 'concierge-pu-rideshare-before',
  // CONCIERGE_PICKUP_RIDESHARE_BOTH: 'concierge-pu-rideshare-both',
  CONCIERGE_RETURN: "concierge-ret",
  CONCIERGE_RETURN_NO_RIDESHARE: "concierge-ret-no-rideshare",
  // CONCIERGE_RETURN_RIDESHARE_AFTER: 'concierge-ret-rideshare-after',
  // CONCIERGE_RETURN_RIDESHARE_BEFORE: 'concierge-ret-rideshare-before',
  // CONCIERGE_RETURN_RIDESHARE_BOTH: 'concierge-ret-rideshare-both',
  CONCIERGE_LOANER_PICKUP: "concierge-loaner-pu",
  // CONCIERGE_LOANER_PICKUP_NO_RIDESHARE: 'concierge-loaner-pu-no-rideshare',
  // CONCIERGE_LOANER_PICKUP_RIDESHARE_AFTER: 'concierge-loaner-pu-rideshare-after',
  // CONCIERGE_LOANER_PICKUP_RIDESHARE_BEFORE: 'concierge-loaner-pu-rideshare-before',
  // CONCIERGE_LOANER_PICKUP_RIDESHARE_BOTH: 'concierge-loaner-pu-rideshare-both',
  CONCIERGE_LOANER_RETURN: "concierge-loaner-ret",
  // CONCIERGE_LOANER_RETURN_NO_RIDESHARE: 'concierge-loaner-ret-no-rideshare',
  // CONCIERGE_LOANER_RETURN_RIDESHARE_AFTER: 'concierge-loaner-ret-rideshare-after',
  // CONCIERGE_LOANER_RETURN_RIDESHARE_BEFORE: 'concierge-loaner-ret-rideshare-before',
  // CONCIERGE_LOANER_RETURN_RIDESHARE_BOTH: 'concierge-loaner-ret-rideshare-both',
  BASE: "base",
  STRANDED_NO_RIDESHARE: "stranded-no-rideshare",
  STRANDED_RIDESHARE_AFTER: "stranded-rideshare-after",
  STRANDED_RIDESHARE_BEFORE: "stranded-rideshare-before",
  STRANDED_RIDESHARE_BOTH: "stranded-rideshare-both",
  STRANDED_SHUTTLE_AFTER: "stranded-shuttle-after",
  TRIANGLE: "triangle",
  SHUTTLE_DRIVE: "shuttle-drive",
  SHUTTLE_LINKER: "shuttle-linker",
  ROUND_TRIP: "round-trip",
  // ROUND_TRIP_NO_RIDESHARE: 'round-trip-no-rideshare',
  ROUND_TRIP_RIDESHARE_AFTER: "round-trip-rideshare-after",
  ROUND_TRIP_RIDESHARE_BEFORE: "round-trip-rideshare-before",
  ROUND_TRIP_RIDESHARE_BOTH: "round-trip-rideshare-both",
  ROUND_TRIP_FLEX: "round-trip-flex",
  // ROUND_TRIP_FLEX_NO_RIDESHARE: 'round-trip-flex-no-rideshare',
  ROUND_TRIP_FLEX_RIDESHARE_AFTER: "round-trip-flex-rideshare-after",
  ROUND_TRIP_FLEX_RIDESHARE_BEFORE: "round-trip-flex-rideshare-before",
  ROUND_TRIP_FLEX_RIDESHARE_BOTH: "round-trip-flex-rideshare-both",
  /**
   * Guest rides. Came from the retired @hopdrive/sdk-dispatch enums along with
   * `createGuestrideWithScenario`, which is the only thing that writes it. Without it that function
   * would set `scenario_key: undefined` on every guest ride — caught by the TypeScript conversion,
   * since the graft re-pointed guestride's constants import at this module.
   */
  GUEST_RIDESHARE: "guest-rideshare"
};
var VALID_SCENARIO_TYPES = Object.values(SCENARIO_TYPES);
var SCENARIO_STATUS = {
  NEW: "new",
  READY: "ready",
  PENDING: "pending",
  UNCONFIRMED: "unconfirmed",
  CONFIRMING: "confirming",
  MANUAL: "manual",
  AUTO: "auto",
  DISPATCHED: "dispatched",
  DECLINED: "declined",
  DEPRECATED: "deprecated"
};
var VALID_SCENARIO_STATUSES = Object.values(SCENARIO_STATUS);
var BUNDLE_SET_TYPES = {
  SINGLE: "single",
  SHUTTLE_GROUP: "shuttle-group",
  RIDESHARE_GROUP: "rideshare-group",
  PROMO_ONLY: "promo-only"
};
var VALID_BUNDLE_SET_TYPES = Object.values(BUNDLE_SET_TYPES);
var BUNDLE_STATUSES = {
  NEW: "new",
  READY: "ready",
  DISPATCHING: "dispatching",
  DISPATCHED: "dispatched",
  FAILED: "failed",
  DEPRECATED: "deprecated"
};
var VALID_BUNDLE_STATUSES = Object.values(BUNDLE_STATUSES);
var OFFER_SOURCES = {
  MANUAL: "manual",
  AUTO: "auto"
};
var VALID_OFFER_SOURCES = Object.values(OFFER_SOURCES);
var OFFER_STATUSES = {
  NEW: "new",
  OFFERED: "offered",
  ACCEPTED: "accepted",
  ASSIGNED: "assigned",
  DECLINED: "declined",
  EXPIRED: "expired",
  RESCINDED: "rescinded"
};
var VALID_OFFER_STATUSES = Object.values(OFFER_STATUSES);
var OFFER_STRATEGIES = {
  TARGETED: "targeted",
  CASCADING: "cascading",
  BROADCAST: "broadcast",
  ROLLING_BROADCAST: "rolling-broadcast"
};
var VALID_OFFER_STRATEGIES = Object.values(OFFER_STRATEGIES);
var DEFAULT_OFFER_STRATEGY = OFFER_STRATEGIES.CASCADING;
var DEFAULT_OFFER_SOURCE = OFFER_SOURCES.AUTO;
var DRIVER_STATUSES = {
  DRAFT: "draft",
  ASSIGNED: "assigned",
  // LEGACY Status, would not be used in the new system.
  ACCEPTED: "accepted"
};
var VALID_DRIVER_STATUSES = Object.values(DRIVER_STATUSES);
var DEFAULT_DRIVER_STATUS = DRIVER_STATUSES.ACCEPTED;
var DRIVER_ACCOUNT_STATUSES = {
  ONLINE: "online",
  OFFLINE: "offline"
};
var DISPATCHABLE_DRIVER_STATUSES = Object.freeze([
  DRIVER_ACCOUNT_STATUSES.ONLINE,
  DRIVER_ACCOUNT_STATUSES.OFFLINE
]);
var DISPATCHABLE_DRIVER_WHERE_CLAUSES = `user: { active: { _eq: true } } status: { _in: ${JSON.stringify(
  DISPATCHABLE_DRIVER_STATUSES
)} }`;
var DEFAULT_BUNDLE_CONFIG = {
  offerStrategy: DEFAULT_OFFER_STRATEGY,
  source: DEFAULT_OFFER_SOURCE,
  initialRadiusMiles: void 0,
  maxRadiusMiles: void 0,
  radiusIncrementMiles: void 0,
  timeoutMinutes: void 0,
  maxDriversPerRound: void 0,
  maxRounds: void 0,
  offerRounds: []
};
var DEFAULT_STRATEGY_PARAMS = {
  [OFFER_STRATEGIES.TARGETED]: {
    ...DEFAULT_BUNDLE_CONFIG,
    offerRounds: [
      {
        round: 1,
        type: "targeted",
        timeoutMinutes: 15,
        completed: false
      }
    ],
    offerStrategy: OFFER_STRATEGIES.TARGETED,
    timeoutMinutes: 15,
    driverIdOverride: null,
    // Must be set explicitly when using targeted
    maxOfferRadiusMiles: 50
  },
  [OFFER_STRATEGIES.CASCADING]: {
    ...DEFAULT_BUNDLE_CONFIG,
    offerRounds: [
      {
        round: 1,
        type: "cascading",
        timeoutMinutes: 10,
        completed: false
      }
    ],
    offerStrategy: OFFER_STRATEGIES.CASCADING,
    initialRadiusMiles: 5,
    maxRadiusMiles: 30,
    radiusIncrementMiles: 5,
    timeoutMinutes: 10,
    maxDriversPerRound: 1,
    maxRounds: 6,
    maxOfferRadiusMiles: 50
  },
  [OFFER_STRATEGIES.BROADCAST]: {
    ...DEFAULT_BUNDLE_CONFIG,
    offerRounds: [
      {
        round: 1,
        type: "broadcast",
        timeoutMinutes: 5,
        completed: false
      }
    ],
    offerStrategy: OFFER_STRATEGIES.BROADCAST,
    radiusMiles: 250,
    maxOfferRadiusMiles: 50,
    maxDrivers: 10,
    timeoutMinutes: 5
  },
  [OFFER_STRATEGIES.ROLLING_BROADCAST]: {
    ...DEFAULT_BUNDLE_CONFIG,
    offerRounds: [
      {
        round: 1,
        type: "rolling-broadcast",
        timeoutMinutes: 10,
        completed: false
      }
    ],
    offerStrategy: OFFER_STRATEGIES.ROLLING_BROADCAST,
    radiusMiles: 250,
    maxOfferRadiusMiles: 50,
    maxDrivers: 20,
    timeoutMinutes: 10
  }
};
var DRIVER_SELECTION_ALGORITHMS = {
  V1_0_0: "v1_0_0"
};
var DRIVER_SELECTION_ALGORITHM_VARIABLES = {
  [DRIVER_SELECTION_ALGORITHMS.V1_0_0]: {
    PROJECTED_EARNINGS_WEIGHT: 0.2,
    PROJECTED_DISTANCE_TO_PICKUP_WEIGHT: 1,
    PROJECTED_IS_AT_PICKUP_WEIGHT: 2,
    DISTANCE_CLIFF_MILES: 5
  }
};
var VALID_DRIVER_SELECTION_ALGORITHMS = Object.values(DRIVER_SELECTION_ALGORITHMS);

// src/common/utils.ts
function buildSyncRequire() {
  if (typeof __require === "function") return __require;
  return null;
}
var consoleLoggerShim = {
  info: (msg, meta) => meta ? console.log(msg, meta) : console.log(msg),
  warn: (msg, meta) => meta ? console.warn(msg, meta) : console.warn(msg),
  error: (msg, meta) => meta ? console.error(msg, meta) : console.error(msg),
  debug: (msg, meta) => meta ? console.debug(msg, meta) : console.debug(msg)
};
function resolveLogger(requireFn) {
  const tryRequire = requireFn ?? buildSyncRequire();
  if (!tryRequire) return consoleLoggerShim;
  try {
    const sdk = tryRequire("@hopdrive/sdk-server-logger");
    if (typeof sdk?.getLogger === "function") {
      return sdk.getLogger();
    }
  } catch {
  }
  return consoleLoggerShim;
}
var logger = resolveLogger();
var OfferAlreadyAcceptedError = class extends Error {
  constructor(message, bundleId, offerId) {
    super(message);
    this.name = "OfferAlreadyAcceptedError";
    this.bundleId = bundleId;
    this.offerId = offerId;
  }
};
function log(prefix, message, meta) {
  logger.info(`[${prefix}] ${message}`, { source: prefix, ...meta });
}
function safeJsonParse({
  jsonString,
  defaultValue = {}
}) {
  if (!jsonString) {
    throw new Error("JSON string is required");
  }
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    logger.warn(`[safeJsonParse] Failed to parse JSON`, {
      source: "safeJsonParse",
      error: error instanceof Error ? error.message : "Unknown error"
    });
    return defaultValue;
  }
}
function safeJsonStringify(obj, defaultValue = "{}") {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    logger.warn(`[safeJsonStringify] Failed to stringify object`, {
      source: "safeJsonStringify",
      error: error instanceof Error ? error.message : String(error)
    });
    return defaultValue;
  }
}
function getNestedProperty(obj, path, defaultValue = void 0) {
  if (!obj) {
    throw new Error("Object is required");
  }
  if (!path) {
    throw new Error("Path is required");
  }
  const properties = path.split(".");
  let value = obj;
  for (const prop of properties) {
    if (value === void 0 || value === null) {
      return defaultValue;
    }
    value = value[prop];
  }
  return value !== void 0 ? value : defaultValue;
}

// src/types/responses.ts
function gqlErrors(res) {
  return res?.errors;
}

// src/bundles/bundleManagement.ts
var GET_BUNDLE_BY_ID = gql`
  query getBundleById($bundleId: bigint!) {
    bundles_by_pk(id: $bundleId) {
      id
      bundle_set_id
      status
      assigned_offer_id
      assignedOffer {
        driver {
          id
          user {
            display_name
          }
        }
      }
      scenarios {
        scenario {
          id
        }
      }
      config
      createdby
      createdat
      updatedby
      updatedat
      bundleset {
        id
        type
      }
    }
  }
`;
var GET_BUNDLE_WITH_MOVES_LIGHTWEIGHT = gql`
  query getBundleWithMoveDetailsLightweight($bundleId: bigint!) {
    bundles_by_pk(id: $bundleId) {
      id
      status
      config
      assignedOffer {
        status
      }
      bundleset {
        id
        type
      }
      scenarios(where: { scenario: { status: { _neq: "deprecated" } } }) {
        scenario_id
        cardinality
        scenario {
          id
          scenario_key
          status
          config
          moves {
            move_id
            cardinality
            move {
              id
              driver_status
              move_type
              pickup_time
              config
              lite
              lane {
                duration_sec
                distance_miles
                origin_location_id
                pickup {
                  latitude
                  longitude
                  nickname
                  address
                }
                destination_location_id
                delivery {
                  latitude
                  longitude
                  nickname
                  address
                }
              }
            }
          }
        }
      }
    }
  }
`;
var GET_BUNDLE_WITH_MOVES = gql`
  query getBundleWithMoveDetails($bundleId: bigint!) {
    bundles_by_pk(id: $bundleId) {
      id
      status
      config
      assignedOffer {
        status
      }
      bundleset {
        id
        type
      }
      scenarios(where: { scenario: { status: { _neq: "deprecated" } } }) {
        scenario_id
        cardinality
        scenario {
          id
          scenario_key
          status
          config
          moves {
            move_id
            cardinality
            move {
              id
              active
              driver_status
              move_type
              pickup_time
              config
              lite
              manual_flag
              usecase_key
              vehicle_gross_weight_lbs
              customer_id
              customer {
                organization_id
              }
              scenariotomoves {
                scenario {
                  type {
                    key
                  }
                }
              }
              lane {
                duration_sec
                distance_miles
                inverse {
                  id
                }
                origin_location_id
                pickup {
                  latitude
                  longitude
                  nickname
                  address
                  region_id
                  timezone
                }
                destination_location_id
                delivery {
                  latitude
                  longitude
                  nickname
                  address
                  region_id
                  timezone
                }
              }
              appayments(
                where: {
                  active: { _eq: 1 }
                  amount: { _gt: 0 }
                  move: {
                    active: { _eq: 1 }
                    _or: [
                      { cancel_status: { _neq: "canceled" } }
                      { cancel_status: { _is_null: true } }
                    ]
                  }
                }
                order_by: { move: { pickup_time: desc } }
              ) {
                amount
              }
            }
          }
        }
      }
    }
  }
`;
var ADD_SCENARIOS_TO_BUNDLE = gql`
  mutation addScenariosToBundle($bundleToScenarios: [bundletoscenarios_insert_input!]!) {
    insert_bundletoscenarios(objects: $bundleToScenarios) {
      affected_rows
      returning {
        bundle_id
        scenario_id
        cardinality
      }
    }
  }
`;
var DELETE_BUNDLE = gql`
  mutation deleteBundle($bundleId: bigint!) {
    delete_bundles_by_pk(id: $bundleId) {
      id
    }
  }
`;
async function getBundleById(client, bundleId) {
  if (!client) {
    throw new Error("GraphQL client is required to get a bundle");
  }
  if (!bundleId) {
    throw new Error("Bundle ID is required");
  }
  try {
    const variables = { bundleId };
    const result = await client.request(GET_BUNDLE_BY_ID, variables);
    if (gqlErrors(result)) {
      log("getBundleById", "Error getting bundle:", { errors: gqlErrors(result) });
      throw new Error("Error getting bundle");
    }
    return result.bundles_by_pk;
  } catch (error) {
    log("getBundleById", `Error getting bundle ${bundleId}: ${error.message}`);
    throw new Error(`Failed to get bundle: ${error.message}`);
  }
}
async function getBundleWithMoveDetails(client, bundleId) {
  if (!client) {
    throw new Error("GraphQL client is required to get bundle details");
  }
  if (!bundleId) {
    throw new Error("Bundle ID is required");
  }
  try {
    const variables = { bundleId };
    const result = await client.request(GET_BUNDLE_WITH_MOVES, variables);
    return result.bundles_by_pk;
  } catch (error) {
    log("getBundleWithMoveDetails", `Error getting bundle details ${bundleId}: ${error.message}`);
    throw new Error(`Failed to get bundle details: ${error.message}`);
  }
}
async function getBundleWithMoveDetailsLightweight(client, bundleId) {
  if (!client) {
    throw new Error("GraphQL client is required to get bundle details");
  }
  if (!bundleId) {
    throw new Error("Bundle ID is required");
  }
  try {
    const variables = { bundleId };
    const result = await client.request(GET_BUNDLE_WITH_MOVES_LIGHTWEIGHT, variables);
    return result.bundles_by_pk;
  } catch (error) {
    log(
      "getBundleWithMoveDetailsLightweight",
      `Error getting bundle details ${bundleId}: ${error?.message || error}`
    );
    throw new Error(`Failed to get bundle details: ${error?.message || error}`);
  }
}
async function updateBundleStatus(client, bundleId, status, options = {}) {
  const { config = {}, user = "system" } = options;
  if (!client) {
    throw new Error("GraphQL client is required to update bundle status");
  }
  if (!bundleId) {
    throw new Error("Bundle ID is required");
  }
  if (!status) {
    throw new Error("Status is required");
  }
  if (!VALID_BUNDLE_STATUSES.includes(status)) {
    throw new Error(`Invalid status. Must be one of: ${VALID_BUNDLE_STATUSES.join(", ")}`);
  }
  log("updateBundleStatus", `Updating bundle ${bundleId} status to ${status}`);
  try {
    const variables = {
      id: bundleId,
      status,
      user
    };
    if (Object.keys(config).length > 0) {
      variables.config = config;
    }
    const query = gql`
      mutation updateBundle(
        $id: bigint!,
        $status: String,
        ${Object.keys(config).length > 0 ? "$config: jsonb," : ""}
        $user: String!
      ) {
        update_bundles_by_pk(
          pk_columns: { id: $id }
          _set: {
            status: $status,
            ${Object.keys(config).length > 0 ? "config: $config," : ""}
            updatedat: "now()",
            updatedby: $user
          }
        ) {
          id
          bundle_set_id
          status
          assigned_offer_id
          config
          createdby
          createdat
          updatedby
          updatedat
          bundleset {
            id
            type
          }
        }
      }
    `;
    const result = await client.request(query, variables);
    if (!result?.update_bundles_by_pk?.id) {
      throw new Error(`Failed to update bundle status`);
    }
    return result.update_bundles_by_pk;
  } catch (error) {
    log("updateBundleStatus", `Error updating bundle ${bundleId} status: ${error.message}`);
    throw new Error(`Failed to update bundle status: ${error.message}`);
  }
}
async function updateBundleStatuses(client, bundleIds, status, options = {}) {
  const { user = "system" } = options;
  if (!client) {
    throw new Error("GraphQL client is required");
  }
  if (!bundleIds || bundleIds?.length === 0) {
    throw new Error("Bundle IDs are required");
  }
  if (!status) {
    throw new Error("Status is required");
  }
  if (!VALID_BUNDLE_STATUSES.includes(status)) {
    throw new Error(`Invalid status. Must be one of: ${VALID_BUNDLE_STATUSES.join(", ")}`);
  }
  log("updateBundleStatuses", `Updating bundle statuses to ${status}`);
  try {
    const variables = {
      ids: bundleIds,
      status,
      user
    };
    const query = gql`
      mutation updateBundleStatuses(
        $ids: [bigint!]!,
        $status: String!,
        $user: String!
      ) {
        update_bundles(
          where: { id: { _in: $ids } }
          _set: { status: $status, updatedby: $user, updatedat: "now()" }
        ) {
          affected_rows
          returning {
            id
            bundle_set_id
            status
            assigned_offer_id
            config
            createdby
            createdat
            updatedby
            updatedat
            bundleset {
              id
              type
            }
          }
        }
      }
    `;
    const result = await client.request(query, variables);
    if (!result?.update_bundles?.affected_rows) throw new Error("Failed to update bundle statuses");
    return result?.update_bundles?.returning;
  } catch (err) {
    log("updateBundleStatuses", `Error updating bundle statuses: ${err.message}`);
    throw new Error(`Failed to update bundle statuses: ${err.message}`);
  }
}
async function updateBundleConfig(client, bundleId, config, options = {}) {
  const { user = "system" } = options;
  if (!client) {
    throw new Error("GraphQL client is required to update bundle config");
  }
  if (!bundleId) {
    throw new Error("Bundle ID is required");
  }
  if (!config) {
    throw new Error("Config object is required");
  }
  log("updateBundleConfig", `Updating config for bundle ${bundleId}`);
  try {
    const variables = {
      id: bundleId,
      config,
      user
    };
    const query = gql`
      mutation updateBundleConfig($id: bigint!, $config: jsonb, $user: String!) {
        update_bundles_by_pk(
          pk_columns: { id: $id }
          _set: { config: $config, updatedat: "now()", updatedby: $user }
        ) {
          id
          bundle_set_id
          status
          assigned_offer_id
          config
          createdby
          createdat
          updatedby
          updatedat
          bundleset {
            id
            type
          }
        }
      }
    `;
    const result = await client.request(query, variables);
    if (!result?.update_bundles_by_pk?.id) {
      throw new Error(`Failed to update bundle config`);
    }
    return result.update_bundles_by_pk;
  } catch (error) {
    log("updateBundleConfig", `Error updating bundle ${bundleId} config: ${error.message}`);
    throw new Error(`Failed to update bundle config: ${error.message}`);
  }
}
function getOriginLocationFromBundle(bundle) {
  try {
    if (!bundle?.scenarios?.length) {
      return null;
    }
    const sortedScenarios = [...bundle.scenarios].sort((a, b) => a.cardinality - b.cardinality);
    const firstScenario = sortedScenarios[0]?.scenario;
    if (!firstScenario?.moves?.length) {
      return null;
    }
    const sortedMoves = [...firstScenario.moves].sort((a, b) => a.cardinality - b.cardinality);
    const firstMove = sortedMoves[0]?.move;
    if (!firstMove?.lane) {
      return null;
    }
    if (firstMove.lane.pickup?.latitude && firstMove.lane.pickup?.longitude) {
      return {
        latitude: firstMove.lane.pickup.latitude,
        longitude: firstMove.lane.pickup.longitude,
        address: firstMove.lane.pickup.address,
        nickname: firstMove.lane.pickup.nickname
      };
    }
    return null;
  } catch (error) {
    log("getOriginLocationFromBundle", `Error: ${error.message}`);
    return null;
  }
}
async function addScenariosToBundle(client, bundleId, scenarioIds, options = {}) {
  const { user = "system" } = options;
  if (!client) throw new Error("GraphQL client is required!");
  if (!bundleId) throw new Error("Bundle ID is required!");
  if (!scenarioIds || scenarioIds.length === 0) throw new Error("Scenario IDs are required!");
  try {
    const variables = {
      bundleToScenarios: scenarioIds.map((scenarioId, index) => ({
        bundle_id: bundleId,
        scenario_id: scenarioId,
        cardinality: index,
        createdat: (/* @__PURE__ */ new Date()).toISOString(),
        createdby: user,
        updatedat: (/* @__PURE__ */ new Date()).toISOString(),
        updatedby: user
      }))
    };
    const result = await client.request(ADD_SCENARIOS_TO_BUNDLE, variables);
    if (!result?.insert_bundletoscenarios?.affected_rows)
      throw new Error("Failed to add scenarios to bundle");
    return result?.insert_bundletoscenarios?.returning;
  } catch (err) {
    log("addScenariosToBundle", `Error adding scenarios to bundle ${bundleId}: ${err.message}`);
    throw new Error(`Failed to add scenarios to bundle: ${err.message}`);
  }
}
async function deleteBundle(client, bundleId) {
  try {
    if (!client) {
      throw new Error("GraphQL client is required to delete bundle");
    }
    if (!bundleId) {
      throw new Error("Bundle ID is required");
    }
    log("deleteBundle", `Deleting bundle ${bundleId}`);
    const variables = { bundleId };
    const result = await client.request(DELETE_BUNDLE, variables);
    if (!result?.delete_bundles_by_pk?.id) {
      throw new Error(`Failed to delete bundle`);
    }
    return result.delete_bundles_by_pk;
  } catch (err) {
    log("deleteBundle", `Error deleting bundle ${bundleId}: ${err?.message}`);
    throw new Error(`Failed to delete bundle: ${err?.message}`);
  }
}

export {
  __require,
  MOVE_TYPES,
  VALID_MOVE_TYPES,
  RIDE_TYPES,
  VALID_RIDE_TYPES,
  RIDE_POSITION,
  VALID_RIDE_POSITIONS,
  USE_CASES,
  VALID_USE_CASES,
  SCENARIO_TYPES,
  VALID_SCENARIO_TYPES,
  SCENARIO_STATUS,
  VALID_SCENARIO_STATUSES,
  BUNDLE_SET_TYPES,
  VALID_BUNDLE_SET_TYPES,
  BUNDLE_STATUSES,
  VALID_BUNDLE_STATUSES,
  OFFER_SOURCES,
  VALID_OFFER_SOURCES,
  OFFER_STATUSES,
  VALID_OFFER_STATUSES,
  OFFER_STRATEGIES,
  VALID_OFFER_STRATEGIES,
  DEFAULT_OFFER_STRATEGY,
  DEFAULT_OFFER_SOURCE,
  DRIVER_STATUSES,
  VALID_DRIVER_STATUSES,
  DEFAULT_DRIVER_STATUS,
  DRIVER_ACCOUNT_STATUSES,
  DISPATCHABLE_DRIVER_STATUSES,
  DISPATCHABLE_DRIVER_WHERE_CLAUSES,
  DEFAULT_BUNDLE_CONFIG,
  DEFAULT_STRATEGY_PARAMS,
  DRIVER_SELECTION_ALGORITHMS,
  DRIVER_SELECTION_ALGORITHM_VARIABLES,
  VALID_DRIVER_SELECTION_ALGORITHMS,
  consoleLoggerShim,
  resolveLogger,
  logger,
  OfferAlreadyAcceptedError,
  log,
  safeJsonParse,
  safeJsonStringify,
  getNestedProperty,
  gqlErrors,
  getBundleById,
  getBundleWithMoveDetails,
  getBundleWithMoveDetailsLightweight,
  updateBundleStatus,
  updateBundleStatuses,
  updateBundleConfig,
  getOriginLocationFromBundle,
  addScenariosToBundle,
  deleteBundle
};
//# sourceMappingURL=chunk-PQYQ2DKQ.mjs.map